import React from 'react'
import { Outlet } from 'react-router-dom'

function MainTask() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainTask